import { Component, OnInit } from '@angular/core';
import { DialogChild } from '../../dialogs/dialog-child';
import { FormGroup, FormControl } from '@angular/forms';
import { Keywords } from './keywords.model';

@Component({
  selector: 'file360-keywords',
  templateUrl: './keywords.component.html',
  styleUrls: ['./keywords.component.scss']
})
export class KeywordsComponent extends DialogChild implements OnInit {

  form: FormGroup;

  keywords: Keywords | undefined;

  constructor() {
    super();
    this.form = new FormGroup({
      'keywords': new FormControl()
    });
  }

  get keywordsField(): FormControl {
    return this.form.get('keywords') as FormControl;
  }

  ngOnInit() {

    this.raiseIsValid(false);

    this.keywords = this.data as Keywords;
    this.keywordsField.setValue(this.keywords.KeywordData, { emitEvent: false });
    if (!this.keywords.AllowAdds) {
      this.keywordsField.disable();
    }
    this.keywordsField.valueChanges.subscribe(value => {
      if (this.keywords != undefined) {
        this.keywords.KeywordData = value;
      }
    });

    this.form.valueChanges.subscribe(() => this.raiseIsValid(this.form.valid));
  }
}
